module.exports = __webpack_public_path__ + "static/media/login-background.26f9c44b.jpg";